import { ApiResponse, http } from '@config/api';
import { CreateInvoiceData, StepsInitial, TermsOfMonitoring } from 'types/monitoring';

export async function getGuidelines(slug: 'monitoring' | 'express'): Promise<any> {
	const response = await http.get<ApiResponse<any>>('requests', `guidelines/${slug}`);

	return response.data ?? [];
}

export async function getTermsOfMonitoring(): Promise<TermsOfMonitoring> {
	const response = await http.get<ApiResponse<TermsOfMonitoring>>(
		'monitoring',
		'terms-of-monitoring/'
	);

	return response.data.data ?? [];
}

export async function getPaymentMethods(): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', 'payment-methods/');

	return response.data.data ?? [];
}

export async function createInvoice(data: CreateInvoiceData) {
	const response = await http.post('monitoring', 'invoice', {
		...data,
	});

	return response.data;
}

export async function submitInitialStep(request: StepsInitial) {
	const response = await http.post<ApiResponse<any>>('monitoring', 'steps/initial', request);

	return response.data;
}
export async function completeInvoiceAction(initialStepId: string, invoice_id: string) {
	// Get the user data from localStorage
	const userDataString = localStorage.getItem('user');
	let fullName = '';
	
	if (userDataString) {
		try {
			const userData = JSON.parse(userDataString);
			// Create fullName from first_name and last_name
			if (userData.first_name && userData.last_name) {
				fullName = `${userData.first_name} ${userData.last_name}`;
			}
		} catch (error) {
			console.error('Error parsing user data from localStorage:', error);
		}
	}
	
	const response = await http.put('monitoring', `steps/complete-invoice-action/${initialStepId}`, {
		invoice_id,
		fullName, // Add the fullName to the payload
	});

	return response.data;
}

export async function placeOrder(initialStepId: string, orderData: any) {
	const response = await http.put('monitoring', `steps/place-order/${initialStepId}`, {
		orderData,
	});

	return response.data;
}

export async function getStoredData(id: number | string): Promise<any> {
	const response = await http.get<ApiResponse<any>>('monitoring', `stored-data/${id}`);

	return response.data.data ?? [];
}
